import computerIcon from '../media/devices/desktop.svg';
import tabletIcon from '../media/devices/tablet.svg';
import smartphoneIcon from '../media/devices/mobile.svg';
import connectedTVIcon from '../media/devices/ctv.svg';

const backgroundPatten = 'repeating-linear-gradient(90deg, transparent, transparent 5px, white 5px, white 8px)';
const gridColumnTemplate = 'minmax(0px, 1fr) minmax(max-content, 18%) minmax(max-content, 18%) minmax(max-content, 18%)';
const gridColumnTemplateFourDevices = 'minmax(0px, 1fr) minmax(max-content, 15%) minmax(max-content, 15%) minmax(max-content, 15%) minmax(max-content, 15%)';
const gridRowTemplate = 'auto auto auto auto';

// colors not in palette
const computerColor = '#0078D4';
const tabletColor = '#00188F';
const smartPhoneColor = '#E3008C';
const connectedTVColor = '#4B003F';

export const getDeviceCardStyle = palette => ({
  '.device-card': {
    display: 'flex',
    flexDirection: 'column',
    '& .device-content-grid': {
      display: 'grid',
      width: '100%',
      marginTop: 15,
      flex: '1',
      gridTemplateColumns: gridColumnTemplate,
      gridTemplateRows: gridRowTemplate,

      '&.device-count-4': {
        gridTemplateColumns: gridColumnTemplateFourDevices,
      },

      '& .graph-area': {
        '& .device-metric': {
          width: '100%',
        },
      },
      '& .device-grid-row-4': {
        '-ms-grid-row': '4',
        gridRow: '4',
        height: 75,
        paddingBottom: 7,
        borderTop: `1px solid ${palette.neutralLighter}`,
        borderBottom: `1px solid ${palette.neutralLighter}`,

        '& .device-metric__metric-picker .metric-picker': {
          '& .dropdown-menu': {
            top: 'auto',
            bottom: '26px',
          },
        },
      },
      '& .device-grid-row-3': {
        '-ms-grid-row': '3',
        gridRow: '3',
        height: 75,
        paddingBottom: 7,
        borderTop: `1px solid ${palette.neutralLighter}`,
      },
      '& .device-grid-row-2': {
        '-ms-grid-row': '2',
        gridRow: '2',
        height: 75,
        paddingBottom: 7,
        marginTop: 7,
        borderTop: `1px solid ${palette.neutralLighter}`,
      },
      '& .device-grid-row-1': {
        '-ms-grid-row': '1',
        gridRow: '1',
      },
      '& .device-grid-row-2 .hover-content': {
        top: '55px !important',
        bottom: 'auto !important',
      },
      '& .device-grid-column-5': {
        '-ms-grid-column': '5',
        gridColumnStart: '5',
      },
      '& .device-grid-column-4': {
        '-ms-grid-column': '4',
        gridColumnStart: '4',
      },
      '& .device-grid-column-3': {
        '-ms-grid-column': '3',
        gridColumnStart: '3',
      },
      '& .device-grid-column-2': {
        '-ms-grid-column': '2',
        gridColumnStart: '2',
      },
      '& .device-grid-column-1': {
        '-ms-grid-column': '1',
        gridColumnStart: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
      '& .device-metric__metric-picker .metric-picker': {
        border: 'none',
        paddingLeft: 0,
        paddingRight: 0,
        height: '26px',

        '& .metric-picker__name': {
          lineHeight: '19px',
        },

        '& .dropdown-menu': {
          left: '0px',
          right: 'auto',
        },
        '& .metric-picker__button--single': {
          flex: '1',
          justifyContent: 'flex-start',
        },
      },
      '& .caret': {
        margin: '0px 9px',
      },
      '& .legend-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: 10,
        fontWeight: '600',
        '& .legend-icon': {
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center center',
          marginRight: 5,
          fontSize: '14px',
          lineHeight: 1,
          fontWeight: 'normal',
          display: 'flex',
          alignItems: 'center',
          height: '15px',
          width: '15px',
        },
        '& .legend-txt': {
          fontSize: '12px',
          lineHeight: '20px',
        },
      },
      '& .device-grid-column-2 .legend-container .legend-txt': {
        color: computerColor,
      },
      '& .device-grid-column-3 .legend-container .legend-txt': {
        color: tabletColor,
      },
      '& .device-grid-column-4 .legend-container .legend-txt': {
        color: smartPhoneColor,
      },
      '& .device-grid-column-5 .legend-container .legend-txt': {
        color: connectedTVColor,
      },
      '& .graph-container': {
        display: 'flex',
        background: palette.neutralLighter,
        position: 'relative',
        width: '100%',

        '& .device-grid-bar': {
          flex: '1 1 0',
        },
        '& .device-grid-bar-computer': {
          backgroundColor: palette.themePrimary,
        },
        '& .device-grid-bar-smartphone': {
          backgroundColor: smartPhoneColor,
        },
        '& .device-grid-bar-tablet': {
          backgroundColor: tabletColor,
        },
        '& .device-grid-bar-connectedtv': {
          backgroundColor: connectedTVColor,
        },
        '& .hover-container': {
          display: 'none',
          position: 'absolute',
          width: '0',
          height: '0',
          left: '0',
          fontSize: 12,
          color: '#333333',
          zIndex: '10',
          '& .hover-content': {
            position: 'absolute',
            padding: '15px 0',
            bottom: 5,
            left: '0',
            boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            '@supports (backdrop-filter: blur(60px))': {
              backdropFilter: 'blur(60px)',
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
            },
          },
          '& .hover-content .device-name': {
            padding: '0 15px',
          },
          '& .hover-content .metric-name': {
            padding: '10px 15px',
          },
          '& .hover-content .hover-kpi-container': {
            display: 'flex',
            whiteSpace: 'nowrap',
          },
          '& .hover-content .hover-kpi-container__date-range': {
            display: 'flex',
            alignItems: 'center',
          },
          '& .hover-content .hover-kpi-container__date-range__color-block': {
            width: 12,
            height: 12,
            marginRight: 3,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-current-computer': {
            background: computerColor,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-current-smartphone': {
            background: smartPhoneColor,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-current-tablet': {
            background: tabletColor,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-current-connectedtv': {
            background: connectedTVColor,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-period-computer': {
            background: computerColor,
            backgroundImage: backgroundPatten,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-period-smartphone': {
            background: smartPhoneColor,
            backgroundImage: backgroundPatten,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-period-tablet': {
            background: tabletColor,
            backgroundImage: backgroundPatten,
          },
          '& .hover-content .hover-kpi-container__date-range .color-block-period-connectedtv': {
            background: connectedTVColor,
            backgroundImage: backgroundPatten,
          },
          '& .hover-content .hover-kpi-container__hover-kpi': {
            padding: '0 15px',
          },
          '& .hover-content .hover-kpi-container .hover-kpi-container__hover-kpi+.hover-kpi-container__hover-kpi': {
            borderLeft: '1px solid #DDDDDD',
          },
          '& .hover-content .hover-kpi-container__value': {
            paddingTop: 10,
            fontWeight: 'bold',
          },
          '& .hover-content__kpi-change': {
            display: 'flex',
            padding: '10px 15px 0',
          },
          '& .hover-content__kpi-change__value': {
            fontWeight: 'bold',
          },
          '& .hover-content:hover': {
            display: 'none',
          },
        },
        '& .computer-detail': {
          left: 5,
        },
        '& .tablet-detail': {
          left: 15,
        },
        '& .smartphone-detail': {
          left: 25,
        },
        '& .connectedtv-detail': {
          left: 35,
        },
      },
      '& .show-computer-hover .computer-detail': {
        display: 'block !important',
      },
      '& .show-smartphone-hover .smartphone-detail': {
        display: 'block !important',
      },
      '& .show-tablet-hover .tablet-detail': {
        display: 'block !important',
      },
      '& .show-connectedtv-hover .connectedtv-detail': {
        display: 'block !important',
      },
      '& .period': {
        position: 'relative',
        marginTop: 6,
        height: 17,
      },
      '& .period .overlay': {
        position: 'absolute',
        display: 'flex',
        top: '0',
        bottom: '0',
        right: '0',
        left: '0',
        background: backgroundPatten,
      },
      '& .current': {
        flex: '1',
      },
      '& .small_graph .minor': {
        display: 'none',
      },
      '& .kpi-container': {
        marginTop: 15,
        height: 50,
        paddingLeft: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      '& .kpi-container .kpi': {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 10,
        alignItems: 'baseline',
      },
      '& .kpi-container .kpi .current-value': {
        fontSize: '12px',
        marginBottom: 5,
        color: '#333333',
      },
      '& .kpi-container .kpi .increase': {
        color: '#006D21',
      },
      '& .kpi-container .kpi .decrease': {
        color: '#D90026',
      },
      '& .kpi-container .kpi .change-percentage': {
        fontSize: '12px',
        marginLeft: 5,
      },
      '& .kpi-container .kpi .period-value': {
        fontSize: '12px',
        color: palette.neutralSecondary,
      },
      '& .computer-icon-img': {
        backgroundImage: `url("${computerIcon}")`,
      },
      '& .smartphone-icon-img': {
        backgroundImage: `url("${smartphoneIcon}")`,
      },
      '& .tablet-icon-img': {
        backgroundImage: `url("${tabletIcon}")`,
      },
      '& .connectedtv-icon-img': {
        backgroundImage: `url("${connectedTVIcon}")`,
      },
    },
    '& .device-links': {
      margin: '10px 0 16px',
    },
    '& .device-links .view-all-clickLink': {
      flex: '0 0 auto',
    },
    '& .device-error': {
      alignSelf: 'center',
      marginTop: '150px',
    },
  },
  '.card-holder .small_layout .device-content-grid .change-percentage': {
    display: 'none',
  },
});
